import { HttpInterceptorFn } from '@angular/common/http';
import { catchError, throwError } from 'rxjs';

export const errorInterceptor: HttpInterceptorFn = (req, next) => {
  return next(req).pipe(
    catchError((err) => {
      if (!err.error) err.error = new Error();
      if (!err.error.detail) {
        switch (err.status) {
          case 401:
            err.error.detail =
              'No tienes privilegios para realizar esto o tu sesión ha expirado y debes iniciar sesión nuevamente.';
            break;
          case 402:
            err.error.detail = 'Hacen falta datos para completar esta operación.';
            break;
          case 403:
            err.error.detail = 'No cuentas con los privilegios para realizar esta acción.';
            break;
          case 404:
            err.error.detail = 'La información que buscas no está disponible.';
            break;
          case 500:
            err.error.detail = 'Error del servidor. Algo salió mal.';
            break;
          default:
            err.error.detail = 'Error del servidor.';
        }
      }
      return throwError(() => err);
    }),
  );
};
